/**
 * @generated SignedSource<<920e906ffddb61cf4d80feb06405d2a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project">;
  readonly " $fragmentType": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project";
};
export type workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project$key = {
  readonly " $data"?: workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_Row_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "1974182e7e485e4aff7803510054da1e";

export default node;
